import http from "@/settings/apiSettings";

class ValoriParametriSalarizareCustomDataService {

  GetValoriParametriSalarizareAngajat(empId: string): Promise<any> {
    return http.clientResurseUmane.get("/Salarizare/GetValoriParametriSalarizareAngajat", {
      params: { empId }
    });
  }

  GetValoriParametriSalarizareCompanie(empId: string): Promise<any> {
    return http.clientResurseUmane.get("/Salarizare/GetValoriParametriSalarizareCompanie", {
      params: { empId }
    });
  }
}

export default new ValoriParametriSalarizareCustomDataService();
